import {
  Id,
  Identifiable,
  Project,
  ProjectResource,
  ResourceTypes,
  Role,
  Tag,
} from "@planzone/dto";
import { Filter as F } from "@planzone/dto";

enum Sorters {
  None,
  Name,
  Role,
  EntryDate,
}

interface SortFunctions {
  [Sorters.None]: (
    list: Identifiable<ProjectResource>[],
  ) => Identifiable<ProjectResource>[];
  [Sorters.Name]: (
    list: Identifiable<ProjectResource>[],
  ) => Identifiable<ProjectResource>[];
  [Sorters.Role]: (
    list: Identifiable<ProjectResource>[],
  ) => Identifiable<ProjectResource>[];
  [Sorters.EntryDate]: (
    list: Identifiable<ProjectResource>[],
  ) => Identifiable<ProjectResource>[];
}

type Filter = F & {
  resourceTypes: ResourceTypes[];
  roles: Identifiable<Role>[];
  areSortedByGroups: boolean;
  inactiveOnly: boolean;
  // Saved filters from before have none.
  activeOnly?: boolean;
  tags: Tag[];
};

interface Props {
  project: Identifiable<Project>;
}

export type { Props, Filter, SortFunctions };

export { Sorters };
